module.exports = __webpack_public_path__ + "static/media/BJ.aa6d71d3.svg";